import React, { Component, Fragment } from 'react'
import Header from '../partials/Header';
import Footer from '../partials/Footer';
import { Col, Container, Row, FormGroup, Label, Form, Button, Card, CardBody, CardTitle, CardSubtitle } from 'reactstrap';

export class AddYourPaymentMethod extends Component {
    render() {
        return (
            <Fragment>
                <Header {...this.props} path={["Home", "Cart"]} heading="Payment" />
                <Container className="margin-top-fix mb-5 text-white-1">
                    <Row className="pay-purchase-container bg-dark-1 justify-content-center">
                        <Col xl={6} lg={9} md={10} xs={11}>
                            <h5>Payment Method</h5>
                            <div className="pay-method-container bg-dark-2 mt-4">
                                <Row className="justify-content-between">

                                    {/* <div className="d-flex">
                                        <input type="radio" />
                                        <h6 className="mx-3">Paypal</h6>
                                        <div className="pay-logo paypal-logo ms-auto"></div>
                                    </div>
                                    <div className="d-flex mt-3">
                                        <input type="radio" checked />
                                        <h6 className="mx-3">Credit Card Or Debit Card</h6>
                                        <div className="pay-logo visa-logo ms-auto"></div>
                                    </div> */}

                                    <Col lg={4} md={3} sm={3}>
                                        <h6>Paypal</h6>
                                    </Col>
                                    <Col lg={3} md={3} sm={4} xs={5}>
                                        <div className="pay-logo paypal-logo"></div>
                                    </Col>
                                </Row>
                                <Row className="justify-content-between mt-3">
                                    <Col xl={8} lg={8} md={7} sm={6}>
                                        <h6>Credit Card Or Debit Card</h6>
                                    </Col>
                                    <Col xl={4} lg={3} md={4} sm={4} xs={6}>
                                        <div className="pay-logo visa-logo"></div>
                                    </Col>
                                </Row>
                                <Col lg={8}>
                                    <Button block className="w-100 bg-purple-1 border-0 py-4 mt-5" style={{ borderRadius: 16 }}>
                                        <i class="fa fa-plus p-1" style={{border: "2px solid", borderRadius: 16 }}></i> <span className = "mx-1">Add Your Payment Method</span></Button>
                                </Col>
                            </div>
                        </Col>
                        <Col xl={5} lg={7} md={8} xs={9} className="pay-summary">
                            <h5>Summary</h5>
                            <Row>
                                <div className="pay-summary-container bg-dark-2 mt-3">
                                    <Row>
                                        <Col lg={5} md={5}>
                                            <div className="checkout-img game-img-5" ></div>
                                        </Col>
                                        <Col lg={7} md={7}>
                                            <div className="text-white-1 checkout-img-desc">
                                                <CardBody>
                                                    <div className="d-flex">
                                                        <CardTitle tag="h6">The Results Are Now...</CardTitle>
                                                        <div className="ms-auto"><i className = "fas fa-trash p-1" style={{color: "#FFC144", border: "2px solid #FFC144", borderRadius: 8 }}>
                                                        </i></div>
                                                    </div>
                                                    <CardSubtitle tag="h6" className="mb-2 text-muted mt-3">San Francisco, mond...</CardSubtitle>
                                                    <CardSubtitle tag="h6" className="mb-2 text-muted mt-3">29 Augh 2021</CardSubtitle>
                                                    <div className="d-flex mt-2">
                                                        <p>Price:</p>
                                                        <p className="px-2 text-green-1">$60</p>
                                                    </div>
                                                </CardBody>
                                            </div>
                                        </Col>
                                    </Row>
                                    <hr className="line4 mt-0" />
                                    <Row>
                                        <Col lg={5} md={5}>
                                            <div className="checkout-img game-img-6" ></div>
                                        </Col>
                                        <Col lg={7} md={7}>
                                            <div className="text-white-1 checkout-img-desc">
                                                <CardBody>
                                                    <div className="d-flex">
                                                        <CardTitle tag="h6">The Results Are Now...</CardTitle>
                                                        <div className="ms-auto"><i className = "fas fa-trash p-1" style={{color: "#FFC144", border: "2px solid #FFC144", borderRadius: 8 }}>
                                                        </i></div>
                                                    </div>
                                                    <CardSubtitle tag="h6" className="mb-2 text-muted mt-3">San Francisco, mond...</CardSubtitle>
                                                    <CardSubtitle tag="h6" className="mb-2 text-muted mt-3">29 Augh 2021</CardSubtitle>
                                                    <div className="d-flex mt-3">
                                                        <p>Price:</p>
                                                        <p className="px-2 text-green-1">$60</p>
                                                    </div>
                                                </CardBody>
                                            </div>
                                        </Col>
                                    </Row>
                                    <div className="d-flex ">
                                        <CardSubtitle tag="h6" className="text-muted">Discount Coupon :</CardSubtitle>
                                        <CardSubtitle tag="h6" className=" px-5 text-muted">$20</CardSubtitle>
                                    </div>
                                    <div className="d-flex mt-2">
                                        <p>Total :</p>
                                        <p className="px-3 text-red-1">$50</p>
                                    </div>
                                    <Button block className="w-100 bg-purple-1 border-0 py-4 " style={{ borderRadius: 16 }}>Modify Cart</Button>
                                </div>
                                <Row className="justify-content-center mt-4">
                                    <Col lg={8}>
                                        <Button block className="w-100 bg-purple-1 border-0 py-4 " style={{ borderRadius: 16 }}>Checkout</Button>
                                    </Col>
                                </Row>
                            </Row>

                        </Col>
                    </Row>
                </Container>
                <Footer />
            </Fragment>
        )
    }
}

export default AddYourPaymentMethod
